// extracted by mini-css-extract-plugin
export default {"record":"style_record__VdgIL","computer":"style_computer__HdvFW","copyContainer":"style_copyContainer__Bsfp6","copyIcon":"style_copyIcon__8POCF"};